module.exports = __webpack_public_path__ + "static/media/4.6ee0d289.JPG";